import React from 'react';

import DatePicker, { registerLocale } from 'react-datepicker';
import { es, enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

registerLocale('es', es);
registerLocale('en', enUS);

const DateTimeAnswer = ({ editableAnswer, setEditableAnswer, type }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const shortLocale = i18n.language ? i18n.language.slice(0, 2) : 'es';

  const isTimeType = type === 'time';

  return (
    <div className={classes.content}>
      <div>
        <DatePicker
          selected={editableAnswer}
          onChange={(newDate) => setEditableAnswer(newDate)}
          showTimeSelect={isTimeType}
          showTimeSelectOnly={isTimeType}
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat={isTimeType ? 'HH:mm' : 'yyyy-MM-dd'}
          className={classes.datePicker}
          locale={shortLocale}
          timeCaption={t('common.time')}
        />
      </div >
    </div>
  );
};

export default DateTimeAnswer;
